var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"accountManagement"}},[_c('add-account',{attrs:{"addModal":_vm.addModal},on:{"close":_vm.closeModal,"reflash":_vm.reflash}},[_vm._v("添加账号")]),_c('amgn-table',{ref:"table",on:{"addAccount":_vm.addAcount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }